import React from 'react';
import { Icon } from './Icon.js';
export const IconShapeCustom = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M17 7.5L17 2H15.42L10 7.5L3 8L2.5 9L5.5 13L1.5 18.5L2.5 19.5L9 16.5L13.5 20H14.5L16 13.5L23.0041 9.5L23 8.5L17 7.5Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconShapeCustom.js.map